<template>
  <span class="energy-label">
    <a v-if="labelImage" href="#" @click.prevent="$refs.modal.show()">
      <energy-efficiency-class :value="efficiencyClass" />
    </a>
    <energy-efficiency-class v-else :value="efficiencyClass" />
    <modal v-if="labelImage" ref="modal" playground>
      <div class="uk-modal-body">
        <img :src="labelImage.url" class="energy-label__image" />
      </div>
    </modal>
  </span>
</template>

<script>
import EnergyEfficiencyClass from '@/components/EnergyEfficiencyClass';
import Modal from '@/components/Modal';

export default {
  name: 'energy-label',
  components: {
    EnergyEfficiencyClass,
    Modal,
  },
  props: {
    efficiencyClass: String,
    labelImage: Object,
  },
};
</script>

<style lang="scss" scoped>
.energy-label__image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// EnergyLabel.vue?76ba8096